import { LoadingState } from "@quest/murka-games-behavior-panther/dist";
import { ingenuity } from "@quest/base-core/dist";
import { IGameStates } from "@quest/base-core/dist/Interfaces";
import { SlotConstants } from "@quest/slot-core";
import { MainGame } from "./MainGame";

// This is only for adding coreModuleList in final game js else use gameConstants directly//
import { game } from "./CoreModuleList";
import { GameServerComm } from "./Platform/GameServerComm";
import { GameParserModel } from "./Platform/GameParserModel";
import { GameParser } from "./Platform/GameParser";
import { WrapperController } from "./Platform/WrapperController";
import { BaseGameStateGame } from "./states/BaseGameStateGame";
import { FreeGameStateGame } from "./states/FreeGameStateGame";

import { base } from "@quest/base-core/dist/CoreModuleList";

import { BaseCoreEventConstants, dispatcher, EventConstants, Loading, SpineBase } from "@quest/base-core";
import { BaseView } from "@quest/base-core";

export class Game {
  public serverComm: GameServerComm;
  public parser: GameParser;
  public parserModel: GameParserModel;
  public wrapper: WrapperController;

  constructor(cdn: boolean) {
    this.parserModel = new GameParserModel();
    this.parserModel.setBalance(0);
    this.parserModel.setUserBalance(0);
    ingenuity.parserModel = this.parserModel;
    ingenuity.cdn = cdn;

    this.serverComm = new GameServerComm(this.parserModel);
    this.parser = new GameParser(this.parserModel);

    const stateObj: IGameStates = {
      load: LoadingState as any,
      [SlotConstants.baseGameState]: BaseGameStateGame as any,
      [SlotConstants.freeGameState]: FreeGameStateGame as any,
    };
    new MainGame(
      game.gameConstants.GAME_CONTAINER_DIV,
      {
        desktop: {
          width: 1280,
          height: 720,
        },
        mobile: {
          width: 1280,
          height: 720,
        },
        mobilePortrait: {
          width: 720,
          height: 1280,
        },
      },
      stateObj
    );

    this.wrapper = new WrapperController();
  }
}
(window as any).Game = Game;
(window as any).ingenuity = ingenuity;

/** Monkey patching, since this class is used well within the libraries
 * fix : ID and spine Name Can be different for spine
 */
//@ts-ignore
BaseView.prototype.createSpine = function (json): SpineBase {
  if (Loading.isSpineLoaded(json.image)) {
    //@ts-expect-error
    const spine = new base.Spine(json);
    if (json.parent) {
      this.containers[json.parent].addChild(spine);
    } else {
      this.addChild(spine);
    }
    json.key = json.key ? json.key : json.id;
    this.spines[json.key] = spine;
    this.allComponents[json.id] = spine;
    dispatcher.fireEvent(EventConstants.COMPONENT_CREATED, spine);
    return spine;
  } else {
    dispatcher.on(BaseCoreEventConstants.FILE_LOADED, (evt) => {
      if ((evt.data === json.image || evt.data === json.image + ".png") && Loading.isImageLoaded(evt.data)) {
        evt.remove();
        // adding delay so that the currentGame.cache.spine has the entry of the loaded spine, if it is not in cache it does not create the spine and we do not have
        // any event as of now by which we can check if the spine is loaded in the cache after the files are loaded fileLoadComplete on our loader is called before fileLoadComplete of Spine
        // utils.delayedCall(core.base.constants.delayKeys.SPINE_CREATION_DELAY, 1, (jsonArray: ISpineData[]) => {
        this.createSpine(json);
        // }, this, json);
      }
    });
  }
};
